module.exports = __webpack_public_path__ + "img/pin-restaurant-pink.d85617df.png";